<template>
	<div class="pheno">
		<Loading msg="loading" v-if="!isload" />
		<!-- 表型检测  折线图页面 -->
		<div class="phenotypic_home" v-else>
			  	<img @click="$parent.goBack()"
          v-if="!pheno_only"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
			<div class="phenotypic_home_up">
		
				<h1 class="pheno_title">现状结果/&nbsp;<span class="pheno_record_time">{{record_date}}</span></h1>
				
				<div class="pheno_face_box">
					<span class="pheno_result pheno_skintype_result" @click="$parent.routerGo('/skintype/'+bar_code, (actParams = { query: $route.query, pageid: 399 }),{is_access:true,reportEvent_page_id:'399',reportEvent_page_name:'表型-肤质',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果',reportEvent_second_module:'肤质'})">肤质:{{phenotypic_data.oil_result}}</span>
					<span class="pheno_result pheno_dqm_result" @click="$parent.routerGo('/barrier/'+bar_code, (actParams = { query: $route.query, pageid: 400 }),{is_access:true,reportEvent_page_id:'400',reportEvent_page_name:'表型-屏障',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果',reportEvent_second_module:'屏障'})">屏障:{{phenotypic_data.dqm_result_show_info}}</span>
					<span class="pheno_result pheno_pm_result" @click="$parent.routerGo('/melanin/'+bar_code, (actParams = { query: $route.query, pageid: 401 }),{is_access:true,reportEvent_page_id:'401',reportEvent_page_name:'表型-黑色素',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果',reportEvent_second_module:'黑色素'})">黑色素:{{phenotypic_data.pm_result_area_level}}</span>
					<span class="pheno_pm_per_result" v-if="phenotypic_data.pm_result_percent>=90"> <img src="../assets/images/thumb_icon.png" class="thumb_icon" alt="">&nbsp;优于{{phenotypic_data.pm_result_percent}}%的人</span>
					<span class="pheno_dqm_per_result" v-if="phenotypic_data.dqm_result_percent>=90"> <img src="../assets/images/thumb_icon.png" class="thumb_icon" alt="">&nbsp;优于{{phenotypic_data.dqm_result_percent}}%的人</span>
				</div>
				<div class="pheno_score_box">
					<span class="pheno_score">{{phenotypic_data.total_score}}</span>
					<span>分</span>
				</div>
				<p class="pheno_score_text">{{phenotypic_data.pk_percent_show_info}}</p>
				<div class="pheno_submit_box">
					<div class="submit_title_box">
						<span class="submit_title" :class="show_potential ? 'now' : ''" @click="show_potential=true;">潜在问题</span>
						<span class="submit_title" :class="!show_potential ? 'now' : ''" @click="show_potential=false;$parent.trackLog((actParams = { query: $route.query, pageid:402 }),{is_access:true,reportEvent_page_id:402,reportEvent_page_name:'表型首页-补救措施',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果',reportEvent_second_module:'首页'});">补救措施</span>
					</div>
						<div class="submit_text_box">
							<div class="submit_text_tip_box">
								<img src="../assets/images/attention_icon.png" class="tip_icon" alt="">
								<span class="tip_text">需要注意</span>
							</div>
							<p class="submit_text potential_text" v-show="show_potential"><span v-for="(item,idx) in potential_arr" :key="idx">• {{item}}<br></span></p>
							<p class="submit_text remedy_text" v-show="!show_potential"><span v-for="(item,idx) in remedy_arr" :key="idx">• {{item}}<br></span></p>
						
						</div>
				</div>

        <!-- 20190917修改 -->
        			
			<!-- 潜在问题 -->
			<div class="potential_part">
				<div class="potential_part_title">潜在问题</div>
				<div class="potential_part_down">
					<div class="potential_part_down_title">需要注意:</div>
					<ul class="potential_part_ul">
						<li class="potential_part_info" v-for="(item,idx) in potential_arr" :key="idx">• {{item}}</li>
						<!-- <li class="potential_part_info">• 屏障有轻微损伤,如果不及时修复,可能有皮肤敏感的趋势</li> -->
						<!-- <li class="potential_part_info">• 可能会有晒伤风险,要注意哦~</li> -->
					</ul>
				</div>
			</div>

			<!-- 补救措施 -->
			<div class="remedy_part">
				<div class="remedy_part_title">补救措施</div>
				<div class="remedy_part_down">
					<div class="remedy_part_down_title">需要注意:</div>
					<ul class="remedy_part_ul">
						<li class="remedy_part_info" v-for="(item,idx) in remedy_arr" :key="idx">• {{item}}</li>
						<!-- <li class="remedy_part_info">• 屏障有轻微损伤,如果不及时修复,可能有皮肤敏感的趋势</li> -->
						<!-- <li class="remedy_part_info">• 可能会有晒伤风险,要注意哦~</li> -->
					</ul>
					<div class="remedy_part_down_title_2">适用成分</div>
					<ul class="remedy_part_ing_ul">
						<li class="remedy_part_ing_li" v-for="(ing,idx) in phenotypic_data.ingredients" :key="idx">
							<div class="remedy_part_ing_li_name">• <span>{{ing.ingredient}}</span></div>
							<p class="remedy_part_ing_li_desc">{{ing.ingredient_desc}}</p>
						</li>
						<!-- <li class="remedy_part_ing_li">
							<div class="remedy_part_ing_li_name">• <span>野大豆醇类</span></div>
							<p class="remedy_part_ing_li_desc">维持角质层中层状脂质结构，从而帮助受损肌肤恢复天然屏障功能</p>
						</li>
						<li class="remedy_part_ing_li">
							<div class="remedy_part_ing_li_name">• <span>野大豆醇类</span></div>
							<p class="remedy_part_ing_li_desc">维持角质层中层状脂质结构，从而帮助受损肌肤恢复天然屏障功能</p>
						</li> -->
					</ul>
				</div>
			</div>




			</div>
			<div class="pheno_history_map">
				<div class="map_title">测肤历史/&nbsp;<span>持续跟踪你的肌肤状态</span></div>
				<div class="map_main"><v-chart id="pheno_main" :options="EChartsOption" /></div>
			
			</div>
			<div class="pheno_progress_lists">
				<div class="single_list" v-for="(v, i) in HistoryObj[Type].progress_total" :key="i">
					<h6 class="single_list_title" v-if="v.time != HistoryObj[Type].current_year">{{ v.time }}年</h6>
					<ul>
						<li v-for="(value, idx) in v.progress" :key="idx" class="list_single_item pheno_bar_code" @click="goPheno(value.bar_code)">
							<h5 class="single_item_title">{{ value.time.split('-')[1] }}月{{ value.time.split('-')[2] }}日</h5>
							<div class="single_item_detail">
								<div class="detail_progress">
								
									<div
										class="progress"
										:style="'width:' + (value[HistoryObj[Type].score_type]) + '%'"
									></div>
								</div>
								<div class="detail_text_box">
									<span class="detail_text">{{ value[HistoryObj[Type].score_type] }}分</span>
									<img src="https://static.inertiabiotech.com/uniskin/reportv3/images/arrow_right_d.png" class="detail_text_icon" alt="" />
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

      <!-- 表型首页添加表型跳转菜单 -->
      <div class="pheno_retest" @click="$parent.routerGo('/moreservices',(actParams = { query: $route.query, pageid: 356 }),{is_access:true,reportEvent_page_id:'356',reportEvent_page_name:'更多升级',reportEvent_report_type:'199基因',reportEvent_first_module:'更多升级'})"><span>添加复测</span><img src="../assets/images/arrow_right_c.png" alt=""></div>
		</div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
// import sensors from "sa-sdk-javascript";
export default {
  name: "Pheno",
  data() {
    return {
      isload: false,
      show_potential: true, //潜在问题 补救措施
      bar_code: "",
      pheno_only:false,  //只有表型数据
      phenotypic_data: {},
      potential_arr: [],
      remedy_arr: [],
      record_date: "",
      history_str: "",
      Type: "pheno",
      cateType: "skintype",
      EChartsOption: {},
      HistoryObj: {}
    };
  },
  created() {
    console.log("Pheno created");
    this.bar_code = this.$route.params.bar_code || "";
    this.initPhenoTypicHome(this.$route.params.bar_code || "");
  },
  mounted() {
    // let myEcharts = ECharts.init(document.getElementById("pheno_main"));
    // setTimeout(function(){
    //     myEcharts.dispatchAction({
    //         type: 'showTip',
    //         seriesIndex:0,  // 显示第几个series
    //         dataIndex: 2 // 显示第几个数据
    //     });
    // },1000)
    // this.LFEvent({is_access:true,reportEvent_page_id:'353',reportEvent_page_name:'现状结果',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果'});
  },
  watch: {
    $route(to, from) {
      console.log("to", to);
      this.initPhenoTypicHome(to.params.bar_code || "");
      console.log(to.params.bar_code);
    }
  },
  // beforeRouteUpdate (to,from,next){
  // 	this.bar_code = to.params.bar_code;
  // 	alert(to.params.bar_code)
  // 	next( vm =>{
  // 		vm.initPhenoTypicHome(this.$route.params.bar_code || '');
  // 	})

  // },
  methods: {
    initPhenoTypicHome: function(bar_code) {
      let that = this;
      var local_phenoTypicHome = JSON.parse(
        localStorage.getItem("local_phenoTypicHome")
      );
      if (local_phenoTypicHome && !bar_code) {
        afterPhenoTypicHome(local_phenoTypicHome);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/skin_detection/index",
            { bar_code }
          )
          .then(json => {
            // Success.
            console.log("phenohome", json);
            // localStorage.setItem(
            //   "local_phenoTypicHome",
            //   JSON.stringify(json)
            // );

            afterPhenoTypicHome(json);
          })
          .catch(err => {
            // Failed.
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }

      function afterPhenoTypicHome(pheno_data) {
        //0628  无黑色素数据 添加提示
        if (pheno_data.code == 109) {
          alert(pheno_data.msg);
        } else if (pheno_data.code == 0) {
          console.log(pheno_data);

          that.phenotypic_data = pheno_data.gene_result;
          that.potential_arr = pheno_data.gene_result.question[0];
          that.remedy_arr = pheno_data.gene_result.question[1];
          that.record_date =
            pheno_data.gene_result.create_time.split("-")[0] +
            "年" +
            pheno_data.gene_result.create_time.split("-")[1] +
            "月" +
            pheno_data.gene_result.create_time.split("-")[2] +
            "日的检测";
          return that.initHistoryData();
        }
      }
    },
    initHistoryData: function() {
      let that = this;

      //比较时间 判断是否过期
      // if ((new Date().getTime() - JSON.parse(localStorage.getItem('local_storage_time'))) > 1000*60*60*24*7 || !localStorage.getItem("local_storage_time")){
      // 	localStorage.clear();
      // }

      //历史记录页去除缓存
      var local_inputFaceBarcode = JSON.parse(
        localStorage.getItem("local_inputFaceBarcode")
      );
      if (local_inputFaceBarcode) {
        afterInputFaceBarcode(local_inputFaceBarcode);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/newface/new_face_controller/inputFaceBarcode",
            { bar_code: "" }
          )
          .then(json => {
            // Success.
            console.log("482", json);
            //历史纪录页面  去除缓存
            // localStorage.setItem('local_inputFaceBarcode', JSON.stringify(json));

            // 第一次初始化时  本地存储时间戳 用于用于过期时间比较
            // localStorage.setItem('local_storage_time', JSON.stringify(new Date().getTime()));
            afterInputFaceBarcode(json);
          })
          .catch(err => {
            // Failed.
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }

      function afterInputFaceBarcode(history_data) {
        if (history_data.code == 201) {
          location.href =
            "https://www.uniskin.com.cn/mall/member/account/bind?from=pheno";
        } else if (history_data.code == 103) {
          // 无基因问卷
          localStorage.clear();
          alert("请先填写基因问卷");
          location.href =
            "https://www.uniskin.com.cn/homepage/questionnaire/questionnaire_uni.html";
        } else if (history_data.code == 104) {
          // 无表型问卷
          localStorage.clear();
          alert("请先填写表型问卷");
          location.href =
            "https://www.uniskin.com.cn/homepage/questionnaire_pheno/questionnaire_pheno.html";
        } else if (history_data.code == 107) {
          // 无表型数据
          localStorage.clear();
          alert("您尚没有表型数据");
          // $(".gene_pheno_test_box").css("display", "none");
        } else {
         
          

          //填充表型进度条页面及配置折线图数据
          function groupBy(objectArray, property) {
            return objectArray.reduce(function(acc, obj) {
              var key = obj[property].split("-")[0];
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(obj);
              return acc;
            }, {});
          }

          var score_record = [];
          var date_record = [];
          var oil_record = [];
          var skinlayer_record = [];
          var frk_record = [];

          var pheno_record_data = history_data.data.new_face_data.all_face;

          //将每次监测对应的三项表型标签分别存入不同数组
          var pheno_record_len = pheno_record_data.length;

          for (var i = pheno_record_len - 1; i >= 0; i--) {
            oil_record.push(pheno_record_data[i].all_face_type[0]);
            skinlayer_record.push(pheno_record_data[i].all_face_type[1]);
            frk_record.push(pheno_record_data[i].all_face_type[2]);
            date_record.push(pheno_record_data[i].time.split("-").join("."));
            score_record.push(pheno_record_data[i].total_score);
          }

          //将表型记录对应的进度条数据  按年切割为不同数组
          // console.log(pheno_record_data);
          var pheno_grouped_year = groupBy(pheno_record_data, "time");
          // console.log(pheno_grouped_year);

          //然后将整个对象 单独作为元素  存入新数组中用于循环
          var pheno_progress_arr = [];

          for (var k in pheno_grouped_year) {
            pheno_progress_arr.push({
              progress: pheno_grouped_year[k],
              time: k
            });
          }
          console.log(pheno_progress_arr);

          pheno_progress_arr.sort(function(a, b) {
            return b.time - a.time;
          });
          console.log("pheno_progress_arr", pheno_progress_arr);

          var my_year = new Date().getFullYear();
          //同时渲染表型进度条
          that.HistoryObj = {
            pheno: {
              title: "表型检测记录",
              score_type: "total_score",
              current_year: my_year,
              progress_total: pheno_progress_arr
            }
          };

          let ECharts_formatter = "{c1}<br />{c2}<br/>{c3}",
            ECharts_series = score_record;

          let EChartsOption = {
            grid: {
              show: "false",
              containLabel: true,
              borderWidth: "0",
              left: "0%",
              right: "0%",
              bottom: "0%",
              width: "auto",
              height: "auto"
            },
            tooltip: {
              formatter: ECharts_formatter,
              show: "true",
              alwaysShowContent: "true",
              backgroundColor: "#fff4f2",
              borderColor: "#f99d9b",
              borderWidth: 1,
              padding: [10, 10, 10, 10],
              textStyle: {
                color: "#f99d9b",
                fontWeight: "lighter",
                fontSize: "13"
              },
              trigger: "axis",
              axisPointer: {
                type: "none",
                label: {
                  show: true,
                  color: "transparent",
                  backgroundColor: "transparent"
                }
              }
            },
            xAxis: {
              data: date_record,
              type: "category",
              splitLine: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  type: "solid",
                  color: "#cfcfcf"
                }
              },
              axisTick: {
                interval: 50,
                show: false
              },
              axisLabel: {
                // color:"transparent",
                fontSize: 14,
                color: "#666",
                backgroundColor: "transparent",
                shadowColor: "transparent"
              }
            },
            yAxis: {
              type: "value",
              axisLine: {
                show: false
              },
              axisTick: {
                interval: 50,
                show: false
              },
              axisLabel: {
                show: false
              },
              show: true,
              splitLine: {
                show: false
              }
            },
            dataZoom: [
              {
                type: "inside",
                start: 1,
                end: 100
              }
            ],
            series: [
              {
                name: "score",
                type: "line",
                symbol: "circle",
                symbolSize: "10",
                itemStyle: {
                  normal: {
                    color: "#f99d9b",
                    borderColor: "#f99d9b",
                    opacity: 0.8,
                    label: {
                      fontSize: 18,
                      show: true,
                      color: "#000"
                    }
                  }
                },
                lineStyle: {
                  color: "#f99d9b"
                },
                data: ECharts_series
              },
              {
                name: "控油指数",
                type: "line",
                symbol: "circle",
                symbolSize: "10",
                itemStyle: {
                  normal: {
                    color: "#f99d9b",
                    borderColor: "#f99d9b",
                    opacity: 0.8,
                    label: {
                      show: true,
                      color: "#000"
                    }
                  }
                },
                lineStyle: {
                  color: "#f99d9b"
                },
                data: oil_record
              },
              {
                name: "角质指数",
                type: "line",
                symbol: "circle",
                symbolSize: "10",
                itemStyle: {
                  normal: {
                    color: "#f99d9b",
                    borderColor: "#f99d9b",
                    opacity: 0.8,
                    label: {
                      show: true,
                      color: "#000"
                    }
                  }
                },
                lineStyle: {
                  color: "#f99d9b"
                },
                data: skinlayer_record
              },
              {
                name: "潜在斑风险",
                type: "line",
                symbol: "circle",
                symbolSize: "10",
                itemStyle: {
                  normal: {
                    color: "#f99d9b",
                    borderColor: "#f99d9b",
                    opacity: 0.8,
                    label: {
                      show: true,
                      color: "#000"
                    }
                  }
                },
                lineStyle: {
                  color: "#f99d9b"
                },
                data: frk_record
              }
            ]
          };
          that.EChartsOption = EChartsOption;
           
          return that.getBarcodeStatus();
        }
      }
    },
    //获取baor_code 状态 判断是否存在基因数据 展示返回按钮
    getBarcodeStatus: function() {
      let that = this;
      var local_barcode_status = JSON.parse(localStorage.getItem("local_barcode_status"));
      if (local_barcode_status) {
        afterBarcodeStatus(local_barcode_status);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/gene_july_one/index"
          )
          .then(json => {
            console.log(json);
            // localStorage.setItem("local_barcode_status",JSON.stringify(json));
            afterBarcodeStatus(json);
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterBarcodeStatus(bar_code_status_data) {
      if (bar_code_status_data.code == 100) {
          // 未登录
          localStorage.clear();
          alert("请先登录");
          location.href =
            "https://www.uniskin.com.cn/mall/member/account/login";
        } else{
           
          that.isload = true;
          if(!bar_code_status_data.flag){
             that.pheno_only = true;
            //  alert(that.pheno_only);
          }
         
        
        }
      }
    },
    goPheno: function(bar_code) {
      this.bar_code = bar_code;
      return this.$router.push("/pheno/" + bar_code);
    },
       LFEvent: function(trackData) {
      console.log(trackData);
      //神策事件追踪
      if (trackData){window.linkflow.sendEvent({"reportEvent":trackData})};
      // if (trackData)
      //   sensors.track('reportEvent',trackData);
    },
  },
  components: {
    Loading,
    "v-chart": ECharts
  }
};
</script>
<style lang="less" scoped>
//20190917  修改 表型首页
	.potential_part{
    display:none;
    .shadow;
    .border-radius(14/50rem);
		background:@bg_c_l;
		margin-bottom:45/50rem;
		.potential_part_title{
			padding:27/50rem 0 24/50rem;
			border-bottom:1px solid @font-c-detail;
			text-align:center;
			font-size:34/50rem;
			line-height:1em;
			font-weight:bold;
			color:#333;
		}
		.potential_part_down{
			padding:32/50rem 30/50rem 40/50rem;
			.potential_part_down_title{
				padding-bottom:20/50rem;
				font-size:28/50rem;
				line-height:1em;
				color:@font-c-detail;
			}
			.potential_part_info{
				font-size:24/50rem;
				line-height:36/50rem;
				color:#333;
			}
		}
	}
	.remedy_part{
    display:none;
		.shadow;
		.border-radius(14/50rem);
		background:@bg_c_l;
		margin-bottom:45/50rem;
		.remedy_part_title{
			padding:27/50rem 0 24/50rem;
			border-bottom:1px solid @font-c-detail;
			text-align:center;
			font-size:34/50rem;
			line-height:1em;
			font-weight:bold;
			color:#333;
		}
		.remedy_part_down{
			padding:32/50rem 30/50rem 40/50rem;
			.remedy_part_down_title{
				padding-bottom:20/50rem;
				font-size:28/50rem;
				line-height:1em;
				color:@font-c-detail;
			}
			.remedy_part_down_title_2{
				padding:25/50rem 0 20/50rem;
				font-size:28/50rem;
				line-height:1em;
				color:@font-c-detail;
			}
			.remedy_part_info{
				font-size:24/50rem;
				line-height:36/50rem;
				color:#333;
			}
			.remedy_part_ing_li_name{
				font-size:28/50rem;
				line-height:1em;
				color:#333;
				span{
					border-bottom:1px solid #000;
				}
			}
			.remedy_part_ing_li_desc{
				padding:8/50rem 0 25/50rem;
				font-size:24/50rem;
				line-height:26/50rem;
				color:#999;
			}
		}
  }
  

* {
  padding: 0;
  margin: 0;
}
.pheno_retest{
  border:1/50rem solid @font-c-detail;
  width:240/50rem;
  height:68/50rem;
  margin:0 auto 3rem;
  .border-radius(41/50rem);
  .display_flex;
  .flex-wrap_nowrap;
  .justify-content_flex-center;
  span{
    .flex_0;
    .align-self_center;
    font-size:36/50rem;
    line-height:68/50rem;
    color:@font-c-detail;
    margin-right:12/50rem;
  }
  img{
    .flex_0;
    .align-self_center;
    width:14/50rem;
    height:27/50rem;

  }
}
.back_btn {
  position: fixed;
  top: 30/50rem;
  left: 0;
  z-index: 99999;
  width: 118/50rem;
  height: 54/50rem;
}

.pheno_history_map {
  padding: 120/50rem 0 0;
  .map_title {
    padding: 0 0 30/50rem 30/50rem;
    font-size: 44/50rem;
    line-height: 1em;
    font-weight: bold;
    color: #333;
    span {
      font-size: 30/50rem;
      line-height: 1em;
      font-weight: normal;
      color: #666;
    }
  }
  .map_main {
    height: 400/50rem;
    width: 100%;
  }
}

/* 表型数据  折线图样式 */
#pheno_main {
  width: 98%;
  height: 100%;
  margin: 0 auto;
}

#pheno_main > div {
  height: 100% !important;
  width: 100% !important;
}
#pheno_main canvas {
  height: 100% !important;
  width: 90% !important;
}

.phenotypic_home {
  background: @bg_c_m;
  position: relative;
  padding: 107/50rem 0 40/50rem;
  .phenotypic_home_up {
    padding: 0 30/50rem 0/50rem;
    // border-bottom:1px solid #fff;
  }
  .pheno_back {
    position: fixed;
    z-index: 8888;
    top: 30/50rem;
    left: 0;
    height: 54/50rem;
    width: 118/50rem;
  }
  .pheno_title {
    font-size: 44/50rem;
    line-height: 1em;
    font-weight: bold;
    color: #333;
    padding-bottom: 84/50rem;
  }
  .pheno_record_time {
    font-size: 30/50rem;
    line-height: 1em;
    color: #666;
    font-weight: normal;
  }
  .pheno_face_box {
    position: relative;
    width: 327/50rem;
    height: 327/50rem;
    margin: 0 auto;
    background: url("../assets/images/phenotypic_face.png") no-repeat 0 0;
    background-size: 100%;
    .pheno_result {
      position: absolute;
      width: 225/50rem;
      height: 66/50rem;
      box-shadow: 3px 3px 13px 1px rgba(213, 213, 213, 0.74);
      background: #fff;
      border-radius: 14/50rem;
      font-size: 28/50rem;
      line-height: 66/50rem;
      text-align: center;
      color: #fff;
      &:after {
        content: "";
        position: absolute;
        right: -15/50rem;
        top: 52%;
        transform: translateY(-50%);
        width: 33/50rem;
        height: 33/50rem;
        border-radius: 50%;
        background: url("../assets/images/arrow_icon_white.png") no-repeat 0 0;
        background-size: 11/50rem 20/50rem;
        background-position: center;
      }
    }
    .pheno_skintype_result {
      width: 200/50rem !important;
      top: 15/50rem;
      right: -120/50rem;
      .gradient(to right, @pheno-s-1, @pheno-e-1);
      &:after {
        background: #71c3c2 url("../assets/images/arrow_icon_white.png")
          no-repeat 0 0;
        background-size: 11/50rem 20/50rem;
        background-position: center;
      }
    }
    .pheno_dqm_result {
      width: 200/50rem !important;
      top: 144/50rem;
      left: -170/50rem;
      .gradient(to right, @pheno-s-2, @pheno-e-2);
      &:after {
        background: #7299e7 url("../assets/images/arrow_icon_white.png")
          no-repeat 0 0;
        background-size: 11/50rem 20/50rem;
        background-position: center;
      }
    }
    .pheno_pm_result {
      width: 220/50rem !important;
      top: 210/50rem;
      right: -145/50rem;
      .gradient(to right, @pheno-s-3, @pheno-e-3);
      &:after {
        background: #7f73cb url("../assets/images/arrow_icon_white.png")
          no-repeat 0 0;
        background-size: 11/50rem 20/50rem;
        background-position: center;
      }
    }
    .pheno_pm_per_result {
      position: absolute;
      top: 283/50rem;
      left: 272/50rem;
      font-size: 24/50rem;
      white-space: nowrap;
      color: #666;
      .thumb_icon {
        height: 25/50rem;
        width: 25/50rem;
      }
    }
    .pheno_dqm_per_result {
      position: absolute;
      top: 223/50rem;
      left: -150/50rem;
      font-size: 24/50rem;
      white-space: nowrap;
      color: #666;
      .thumb_icon {
        height: 25/50rem;
        width: 25/50rem;
      }
    }
  }
}
.pheno_score_box {
  padding: 56/50rem 0 8/50rem;
  text-align: center;
  span {
    font-size: 24/50rem;
    line-height: 36/50rem;
    color: #333;
  }
  .pheno_score {
    font-size: 82/50rem;
    line-height: 105/50rem;
    color: #ff9493;
  }
}
.pheno_score_text {
  padding: 0 0 44/50rem;
  text-align: center;
  font-size: 28/50rem;
  line-height: 1em;
  color: #333;
}
.pheno_submit_box {
  // display:none;
  border-radius: 15/50rem;
  background-color: #fff;
  box-shadow: 3px 3px 13px 1px rgba(213, 213, 213, 0.74);
  .submit_title_box {
    display: flex;
    display: -webkit-flex;
    flex-wrap: nowrap;
    -webkit-flex-wrap: nowrap;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    height: 94/50rem;
    border-bottom: 1px solid #f099a6;
    .submit_title {
      position: relative;
      flex: 0 0 auto;
      -webkit-flex: 0 0 auto;
      width: 50%;
      text-align: center;
      font-size: 28/50rem;
      line-height: 94/50rem;
      color: #333;
    }
    .submit_title.now {
      font-weight: bold;
      font-size: 34/50rem;
      // color:#f99d9b;
      border-bottom: 2px solid #f099a6;
      top: 1/50rem;
    }
  }
  .submit_text_box {
    padding: 40/50rem 30/50rem 50/50rem;
    .submit_text_tip_box {
      padding: 0 0 15/50rem;
      display: flex;
      display: -webkit-flex;
      flex-wrap: nowrap;
      -webkit-flex-wrap: nowrap;
      justify-content: flex-start;
      -webkit-justify-content: flex-start;
      .tip_icon {
        align-self: flex-end;
        -webkit-align-self: flex-end;
        width: 30/50rem;
        height: 30/50rem;
        margin-right: 15/50rem;
      }
      .tip_text {
        align-self: flex-end;
        -webkit-align-self: flex-end;
        font-size: 26/50rem;
        line-height: 1em;
        color: #f099a6;
      }
    }
    .submit_text {
      font-size: 24/50rem;
      line-height: 36/50rem;
      color: #333;
    }
  }
}

//进度条

/* 表型进度条区域 */
.pheno_progress_lists {
  padding: 0 30/50rem 66/50rem;
}
.pheno_progress_lists .single_item_title {
  font-size: 34/50rem;
  color: #666;
  line-height: 1em;
  padding: 68/50rem 0 15/50rem;
}
.pheno_progress_lists .single_list_title {
  font-size: 50/50rem;
  line-height: 1em;
  color: #f99d9b;
  padding-top: 50/50rem;
}
.pheno_progress_lists .list_single_item {
  padding-bottom: 20/50rem;
}
.pheno_progress_lists .single_item_detail {
  width: 100%;
  height: 22/50rem;
  position: relative;
  display: flex;
  display: -webkit-flex;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.pheno_progress_lists .detail_progress {
  width: 540/50rem;
  height: 100%;
  background-color: #fcfcfc;
  .border-radius(11/50rem);
  flex: 0 0 auto;
  -webkit-flex: 0 0 auto;
}
.pheno_progress_lists .detail_progress .progress {
  width: 1%;
  height: 100%;
  float: left;
  .border-radius(11/50rem);
  background-color: #f99d9b;
}

.pheno_progress_lists .detail_text_box {
  flex: 0 0 auto;
  -webkit-flex: 0 0 auto;
  display: flex;
  display: -webkit-flex;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.pheno_progress_lists .detail_text {
  flex: 0 0 auto;
  -webkit-flex: 0 0 auto;
  align-self: center;
  -webkit-align-self: center;
  font-weight: normal;
  font-size: 36/50rem;
  line-height: 1em;
  padding-right: 13/50rem;
  box-sizing: border-box;
  color: #333;
  white-space: nowrap;
}
.pheno_progress_lists .detail_text_box .detail_text_icon {
  flex: 0 0 auto;
  -webkit-flex: 0 0 auto;
  align-self: center;
  -webkit-align-self: center;
  width: 20/50rem;
  height: 35/50rem;
}
</style>

